function Index() {
    return import(/* webpackChunkName: "index" */ '@/pages/index.vue')
}
function About() {
    return import(/* webpackChunkName: "about" */ '@/pages/about.vue')
}
function TicketsIndex() {
    return import(
        /* webpackChunkName: "tickets-index" */ '@/pages/tickets/index.vue'
    )
}
function FeedbackIndex() {
    return import(
        /* webpackChunkName: "feedback-index" */ '@/pages/feedback/index.vue'
    )
}
function FormsIndex() {
    return import(
        /* webpackChunkName: "forms-index" */ '@/pages/forms/index.vue'
    )
}
function OrganizationIndex() {
    return import(
        /* webpackChunkName: "organization-index" */ '@/pages/organization/index.vue'
    )
}
function Error404() {
    return import(/* webpackChunkName: "error-404" */ '@/pages/error/404.vue')
}
function Error500() {
    return import(/* webpackChunkName: "error-500" */ '@/pages/error/500.vue')
}
function SearchSearch() {
    return import(
        /* webpackChunkName: "search-Search" */ '@/pages/search/Search.vue'
    )
}
function AdminImports() {
    return import(
        /* webpackChunkName: "admin-imports" */ '@/pages/admin/imports.vue'
    )
}
function AdminEntityeventsIndex() {
    return import(
        /* webpackChunkName: "admin-entityevents-index" */ '@/pages/admin/entityevents/index.vue'
    )
}
function FormsForm() {
    return import(/* webpackChunkName: "forms-Form" */ '@/pages/forms/Form.vue')
}
function AdminFormsIndex() {
    return import(
        /* webpackChunkName: "admin-forms-index" */ '@/pages/admin/forms/index.vue'
    )
}
function FormsAindex() {
    return import(
        /* webpackChunkName: "forms-aindex" */ '@/pages/forms/aindex.vue'
    )
}
function AdminEntityeventsEntityEventListener() {
    return import(
        /* webpackChunkName: "admin-entityevents-EntityEventListener" */ '@/pages/admin/entityevents/EntityEventListener.vue'
    )
}
function OrganizationOrgIdIndex() {
    return import(
        /* webpackChunkName: "organization-orgId-index" */ '@/pages/organization/_orgId/index.vue'
    )
}
function ErrorError() {
    return import(
        /* webpackChunkName: "error-error" */ '@/pages/error/_error.vue'
    )
}
function TicketsTicketId() {
    return import(
        /* webpackChunkName: "tickets-ticketId" */ '@/pages/tickets/_ticketId.vue'
    )
}
function OrganizationOrgIdDirectoryIndex() {
    return import(
        /* webpackChunkName: "organization-orgId-directory-index" */ '@/pages/organization/_orgId/directory/index.vue'
    )
}
function OrganizationOrgIdGroupsIndex() {
    return import(
        /* webpackChunkName: "organization-orgId-groups-index" */ '@/pages/organization/_orgId/groups/index.vue'
    )
}
function OrganizationOrgIdUsersIndex() {
    return import(
        /* webpackChunkName: "organization-orgId-users-index" */ '@/pages/organization/_orgId/users/index.vue'
    )
}
function OrganizationOrgIdDirectoryUnitId() {
    return import(
        /* webpackChunkName: "organization-orgId-directory-unitId" */ '@/pages/organization/_orgId/directory/_unitId.vue'
    )
}
function OrganizationOrgIdGroupsGroupId() {
    return import(
        /* webpackChunkName: "organization-orgId-groups-groupId" */ '@/pages/organization/_orgId/groups/_groupId.vue'
    )
}
function OrganizationOrgIdUsersUserId() {
    return import(
        /* webpackChunkName: "organization-orgId-users-userId" */ '@/pages/organization/_orgId/users/_userId.vue'
    )
}

export default [
    {
        name: 'index',
        path: '',
        component: Index,
    },
    {
        name: 'about',
        path: 'about',
        component: About,
    },
    {
        name: 'tickets-index',
        path: 'tickets',
        component: TicketsIndex,
    },
    {
        name: 'feedback-index',
        path: 'feedback',
        component: FeedbackIndex,
    },
    {
        name: 'forms-index',
        path: 'forms',
        component: FormsIndex,
    },
    {
        name: 'organization-index',
        path: 'organization',
        component: OrganizationIndex,
    },
    {
        name: 'error-404',
        path: 'error/404',
        component: Error404,
    },
    {
        name: 'error-500',
        path: 'error/500',
        component: Error500,
    },
    {
        name: 'search-Search',
        path: 'search/Search',
        component: SearchSearch,
    },
    {
        name: 'admin-imports',
        path: 'admin/imports',
        component: AdminImports,
    },
    {
        name: 'admin-entityevents-index',
        path: 'admin/entityevents',
        component: AdminEntityeventsIndex,
    },
    {
        name: 'forms-Form',
        path: 'forms/Form',
        component: FormsForm,
    },
    {
        name: 'admin-forms-index',
        path: 'admin/forms',
        component: AdminFormsIndex,
    },
    {
        name: 'forms-aindex',
        path: 'forms/aindex',
        component: FormsAindex,
    },
    {
        name: 'admin-entityevents-EntityEventListener',
        path: 'admin/entityevents/EntityEventListener',
        component: AdminEntityeventsEntityEventListener,
    },
    {
        name: 'organization-orgId-index',
        path: 'organization/:orgId',
        component: OrganizationOrgIdIndex,
    },
    {
        name: 'error-error',
        path: 'error/:error?',
        component: ErrorError,
    },
    {
        name: 'tickets-ticketId',
        path: 'tickets/:ticketId?',
        component: TicketsTicketId,
    },
    {
        name: 'organization-orgId-directory-index',
        path: 'organization/:orgId/directory',
        component: OrganizationOrgIdDirectoryIndex,
    },
    {
        name: 'organization-orgId-groups-index',
        path: 'organization/:orgId/groups',
        component: OrganizationOrgIdGroupsIndex,
    },
    {
        name: 'organization-orgId-users-index',
        path: 'organization/:orgId/users',
        component: OrganizationOrgIdUsersIndex,
    },
    {
        name: 'organization-orgId-directory-unitId',
        path: 'organization/:orgId/directory/:unitId?',
        component: OrganizationOrgIdDirectoryUnitId,
    },
    {
        name: 'organization-orgId-groups-groupId',
        path: 'organization/:orgId/groups/:groupId?',
        component: OrganizationOrgIdGroupsGroupId,
    },
    {
        name: 'organization-orgId-users-userId',
        path: 'organization/:orgId/users/:userId?',
        component: OrganizationOrgIdUsersUserId,
    },
]
